import { call, put, takeLatest } from 'redux-saga/effects';
import FilterAction, { FilterTypes } from 'redux/actions/filterAction';
import { getListFilterINC, getListFilterRITM, getListFilterApproval } from 'services/ticketServices';
import BaseAction from '../actions/baseAction';

export function* getFilterINC(action: any): any {
  try {
    const result = yield call(getListFilterINC, action.userName);
    if (result.status === 200) {
      yield put(FilterAction.getListFilterINCSuccess(result.data));
    }
  } catch (error) {
    yield put(BaseAction.errorHandling({
      message: `GET_LIST_FILTER_INC ${error}`
    }));
  }
}

export function* getFilterRITM(action: any): any {
  try {
    const result = yield call(getListFilterRITM, action.userName);
    if (result.status === 200) {
      yield put(FilterAction.getListFilterRITMSuccess(result.data));
    }
  } catch (error) {
    yield put(BaseAction.errorHandling({
      message: `GET_LIST_FILTER_RITM ${error}`
    }));
  }
}

export function* getFilterApproval(action: any): any {
  try {
    const result = yield call(getListFilterApproval, action.userName);
    if (result.status === 200) {
      yield put(FilterAction.getListFilterApprovalSuccess(result.data));
    }
  } catch (error) {
    yield put(BaseAction.errorHandling({
      message: `GET_LIST_FILTER_APPROVAL ${error}`
    }));
  }
}

export const watchFilter = [
  takeLatest(FilterTypes.GET_LIST_FILTER_INC, getFilterINC),
  takeLatest(FilterTypes.GET_LIST_FILTER_RITM, getFilterRITM),
  takeLatest(FilterTypes.GET_LIST_FILTER_APPROVAL, getFilterApproval),
]
